<template>
  <v-card :loading="loading">
    <v-form>
      <v-container>
        <fieldset>
          <legend>Work Details</legend>
          <v-row>
            <!-- <v-col cols="12" sm="6" md="4">
                            <label class="custom-label">Class</label>
                            <v-select
                                    v-model="data.class_name_id"
                                    :error-messages="errors.class_name_id"
                                    :items="$store.getters.classesSelect"
                                    label="Choose Class"
                                    placeholder="Choose Class"
                                    solo
                                    single-line
                            ></v-select>
                        </v-col> -->
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Name</label>
              <v-text-field
                v-model="data.work_name"
                :error-messages="errors.work_name"
                label="Work Name"
                placeholder="Work Name"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Group</label>
              <v-autocomplete
                :error-messages="errors.group_id"
                v-model="data.group_id"
                :items="groups"
                solo
                label="Group"
                placeholder="Group"
                :search-input.sync="group_search"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Type</label>
              <v-select
                v-model="data.type"
                :items="work_types"
                :error-messages="errors.type"
                label="Choose Type"
                placeholder="Choose Type"
                solo
                single-line
              ></v-select>
            </v-col>
            <!-- 
                        <v-col cols="12" sm="6" md="4">
                            <label class="custom-label">Tutor</label>
                            <v-autocomplete
                                    :error-messages="errors.tutor_id"
                                    v-model="data.tutor_id"
                                    :items="tutors"
                                    solo
                                    label="Tutor"
                                    placeholder="Tutor"
                                    :search-input.sync="tutor_search"
                            ></v-autocomplete>

                        </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4">
                            <label class="custom-label">Type</label>
                            <v-select
                                    v-model="data.type"
                                    :items="type"
                                    :error-messages="errors.type"
                                    label="Choose Type"
                                    placeholder="Choose Type"
                                    solo
                                    single-line
                            ></v-select>
                        </v-col> -->

            <!--                        <v-col cols="12" sm="6" md="4">-->
            <!--                            <label class="custom-label">Session</label>-->
            <!--                            <v-select-->
            <!--                                    v-model="selectedSession"-->
            <!--                                    :items="sessions"-->
            <!--                                    label="Choose Session"-->
            <!--                                    placeholder="Choose Session"-->
            <!--                                    solo-->
            <!--                                    single-line-->
            <!--                            ></v-select>-->
            <!--                        </v-col>-->
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Work File</label>
              <v-file-input
                label="Choose File"
                @change="fileSelected"
                accept="application/pdf"
                :error-messages="errors.files"
                persistent-hint
                hint="File Should be PDF"
                show-size
                counter
                chips
                solo
              ></v-file-input>
            </v-col>
            <v-col cols="12" v-if="files.length > 0">
              <h3>Existing Files</h3>
              <p>Can delete them by using cross</p>
            </v-col>
            <v-col cols="12">
              <work-file-chip
                v-for="(file, index) in files"
                :file="file"
                :key="file.id"
                @fileDeleted="removeFile(index)"
              ></work-file-chip>
            </v-col>
          </v-row>
        </fieldset>

        <v-row>
          <v-col cols="12">
            <v-btn @click="save" :loading="loading" color="#6A158E" dark>Save</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import Form from "../../utils/form";
import WorkFileChip from "./WorkFileChip";

export default {
  name: "WorkForm",
  components: { WorkFileChip },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      work_types: ["home", "class"],
      loading: false,
      type: [
        { value: "classes", text: "Class Work" },
        { value: "home", text: "Home Work" },
      ],
      data: {
        class_name_id: null,
        group_id: null,
        subject_id: null,
        tutor_id: null,
        type: null,
        file: null,
      },
      files: [],
      errors: {},
      tutor_search: "",
      tutors: [],
      groups: [],
      group_search: "",
    };
  },
  watch: {
    // "tutor_search"() {
    //     this.getTutors()
    // },
    group_search() {
      this.getGroups();
    },
  },
  methods: {
    removeFile(index) {
      this.files.splice(index, 1);
    },
    fileSelected(file) {
      console.log(file);
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.data.file = reader.result;
        // console.log(reader.result)
      };
      // this.data.files = [...file]
    },
    getTutors() {
      axios
        .get(apiRoutes.tutors.url, {
          params: {
            q: this.tutor_search,
          },
        })
        .then((response) => {
          this.tutors = response.data.results.map((tutor) => {
            return {
              text: tutor.user.first_name,
              value: tutor.user_id,
            };
          });
        });
    },
    getGroups() {
      axios.get(apiRoutes.groups.url, {}).then((response) => {
        // console.log(response)
        this.groups = response.data.response.map((group) => {
          return {
            text: group.group_name,
            value: group.group_id,
          };
        });
      });
    },
    create() {
      this.loading = true;
      let form = new Form({ ...this.data });
      form
        .post(apiRoutes.work.url)
        .then((response) => {
          this.$router.replace({ name: "Works" });
        })
        .catch((response) => {
          if (response.status === 400) {
            this.errors = response.data;
          }
          // alert(response.status)
          if (response.status === 422) {
            //    console.log(response.data)
            this.errors = response.data.errors;
          }
          this.loading = false;
        });
    },
    save() {
      console.log(this.data.file);
      if (this.data.file == null) {
        alert("Please select file!");
        return false;
      }
      if (this.id) {
        this.update();
      } else {
        this.create();
      }
    },
    update() {
      let form = new Form({ ...this.data });
      form
        .put(apiRoutes.work.url + "/" + this.id)
        .then((response) => {
          this.loading = false;
          this.$router.replace({ name: "Works" });
        })
        .catch((response) => {
          // console.log(response)
          if (response.status === 400) {
            this.errors = response.data;
          }
          if (response.status === 422) {
            //    console.log(response.data.errors)
            this.errors = response.data.errors;
          }
          this.loading = false;
        });
    },
  },
  mounted() {
    if (this.id) {
      // alert(this.id)
      axios.get(apiRoutes.work.url + "/" + this.id).then((response) => {
        // console.log(response.data.group)
        this.data.work_name = response.data.work_name;
        this.data.group_id = parseInt(response.data.group.group_id);
        this.data.type = response.data.work_type;
        // this.data.group_id = response.data.group.id
        // this.data.type = response.data.type
        // this.files = response.data.work_files
      });
    }
    // this.getTutors()
    this.getGroups();
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}
</style>
